import { render } from "./ImprintView.vue?vue&type=template&id=bc6388de&scoped=true"
import script from "./ImprintView.vue?vue&type=script&lang=js"
export * from "./ImprintView.vue?vue&type=script&lang=js"

import "./ImprintView.vue?vue&type=style&index=0&id=bc6388de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc6388de"]])

export default __exports__